import { c as _c } from "react/compiler-runtime";
import { TextSkeleton } from '@udemy-v2/react-reveal-components';
import classNames from 'classnames';
import React from 'react';
import styles from './review.module.scss';
interface ReviewSkeletonProps {
  className?: string;
  isDesktopLayout?: boolean;
  inlineLayout?: boolean;
}
const MOBILE_MAX_LINES_IN_REVIEW = 8;
const DESKTOP_MAX_LINES_IN_REVIEW = 5;
export const ReviewSkeleton = t0 => {
  const $ = _c(9);
  const {
    className,
    isDesktopLayout: t1,
    inlineLayout: t2
  } = t0;
  const isDesktopLayout = t1 === undefined ? false : t1;
  const inlineLayout = t2 === undefined ? false : t2;
  const t3 = className ?? null;
  const t4 = isDesktopLayout && inlineLayout;
  let t5;
  if ($[0] !== isDesktopLayout || $[1] !== t3 || $[2] !== t4) {
    t5 = classNames(styles["review-container"], styles["no-vertical-borders"], t3, {
      [styles["review-desktop-container"]]: isDesktopLayout,
      [styles["review-desktop-inline"]]: t4
    });
    $[0] = isDesktopLayout;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = isDesktopLayout ? DESKTOP_MAX_LINES_IN_REVIEW : MOBILE_MAX_LINES_IN_REVIEW;
  let t7;
  if ($[4] !== t6) {
    t7 = <TextSkeleton withTitle={true} lineCountPerParagraph={t6} />;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t5 || $[7] !== t7) {
    t8 = <div data-testid="review-skeleton" className={t5}>{t7}</div>;
    $[6] = t5;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  return t8;
};